var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_29724_195245)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 1,
    width: 40,
    height: 40,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 12.5,
    stroke: "#FF754C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6011 31.4112H29.2794C30.4982 31.4097 31.6667 30.9245 32.5283 30.0624C33.3899 29.2002 33.8745 28.0311 33.8759 26.8117L33.8758 26.0854H34.1177C34.5666 26.0849 34.9971 25.9061 35.3146 25.5885C35.6321 25.2708 35.8106 24.8401 35.811 24.3909L35.8106 22.4542C35.8101 22.005 35.6314 21.5743 35.3138 21.2565C34.9961 20.9388 34.5656 20.7602 34.1166 20.7597H33.8747L33.8746 20.0334C33.8708 18.8824 33.435 17.7751 32.6536 16.9303C31.8723 16.0856 30.8023 15.5652 29.6558 15.4725L26.5878 11.637C26.3039 11.281 25.8884 11.0545 25.4355 11.0086C24.9827 10.9627 24.5303 11.1012 24.1809 11.393L19.2991 15.46H19.299C18.1363 15.5341 17.0453 16.0479 16.2473 16.8972C15.4493 17.7465 15.004 18.8677 15.0018 20.0334L15.0031 26.8116C15.0048 28.031 15.49 29.2001 16.3518 30.0623C17.2138 30.9244 18.3824 31.4096 19.6012 31.4111L19.6011 31.4112ZM34.3589 22.4543L34.3592 24.391C34.3593 24.4552 34.3338 24.5168 34.2885 24.5622C34.2431 24.6076 34.1816 24.633 34.1174 24.633H30.2461C30.1124 24.633 30.004 24.5246 30.0039 24.391L30.0036 22.4543C30.0035 22.3205 30.1119 22.2122 30.2456 22.2122H34.1169C34.1811 22.2122 34.2427 22.2377 34.288 22.2831C34.3334 22.3285 34.3589 22.3901 34.3589 22.4543ZM25.1141 12.5084C25.1632 12.4661 25.2278 12.4465 25.2922 12.4541C25.3571 12.4607 25.4169 12.4932 25.4578 12.5442L27.7656 15.4336H21.6035L25.1141 12.5084ZM16.4535 20.0332C16.4543 19.1988 16.7858 18.3989 17.3755 17.8088C17.965 17.2189 18.7643 16.8871 19.5983 16.886H29.2767C30.1106 16.8871 30.9101 17.2189 31.5 17.8088C32.0898 18.3989 32.4216 19.1988 32.4229 20.0332L32.423 20.7594H30.2454C29.7962 20.7599 29.3658 20.9385 29.0484 21.2563C28.7309 21.574 28.5523 22.0047 28.5519 22.4539L28.5522 24.3906C28.5528 24.8398 28.7316 25.2706 29.0493 25.5883C29.3667 25.9059 29.7973 26.0847 30.2464 26.0852H32.4241L32.4242 26.8114C32.4233 27.6458 32.0917 28.4456 31.5022 29.0356C30.9126 29.6257 30.1132 29.9575 29.2792 29.9584H19.6009C18.7669 29.9575 17.9674 29.6256 17.3777 29.0356C16.7878 28.4456 16.4559 27.6458 16.4548 26.8114L16.4535 20.0332Z",
    fill: "#714FFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_29724_195245",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_29724_195245"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_29724_195245",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderWallet);
export default __webpack_public_path__ + "static/media/header-wallet.5b26d6ec7eac84ab127d67f56794f376.svg";
export { ForwardRef as ReactComponent };